import { datadogLogs } from '@datadog/browser-logs';

export interface MonitorTrackerType {
  collect: (
    key: string,
    value: any,
    type?: LogContent['type'],
    override?: boolean
  ) => void;
  flush: () => void;
  init: () => void;
  setTransferId: (transferId: string) => void;
}

interface LogContent {
  msg: string;
  context: any;
  type: 'INFO' | 'ERROR';
  date: number;
}

let dataCollected: LogContent[] = [];
let lastTransferId = 'NA';

const uploadMonitoringTracker = (): MonitorTrackerType => {
  const collect = (
    msg: string,
    context: any = {},
    type: LogContent['type'] = 'INFO',
    overrideMsg = false
  ): void => {
    if (overrideMsg) {
      const ix = dataCollected.findIndex((dataPoint) => dataPoint.msg === msg);

      if (ix > -1) {
        dataCollected[ix] = { msg, context, type, date: Date.now() };

        return;
      }
    }
    dataCollected.push({ msg, context, type, date: Date.now() });
  };

  // Go through the collected messages and dispatch it to datadogLogs
  const flush = (): void => {
    dataCollected.forEach((value: LogContent) => {
      const context = {
        ...value.context,
        transfer_id: lastTransferId,
        method: 'uploadMonitoringTracker',
        date: value.date,
      };

      if (value.type === 'ERROR') {
        datadogLogs.logger.error(`ERROR: ${value.msg}`, context);
      } else {
        datadogLogs.logger.log(value.msg, context);
      }
    });
  };

  const init = (): void => {
    dataCollected = [];
    lastTransferId = 'Unknown';
  };

  const setTransferId = (transferId: string): void => {
    lastTransferId = transferId;
  };

  return {
    collect,
    flush,
    init,
    setTransferId,
  };
};

export default uploadMonitoringTracker;
